import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import { observer } from "mobx-react-lite";

interface PddCourierDoorToDoorCollectTipProps {
    order: OrderDTO;
}

export function shouldRenderPddCourierDoorToDoorCollectTip(order: OrderDTO) {
    return !!order.tags?.includes(OrderTag.PDD_COURIER_DOOR_TO_DOOR_COLLECT);
}

const PddCourierDoorToDoorCollectTip: React.FC<PddCourierDoorToDoorCollectTipProps> = function (props) {
    const { order } = props;

    if (shouldRenderPddCourierDoorToDoorCollectTip(order)) {
        return (
            <div>
                <span className="error">
                    官方补贴上门揽收。请您关注上门揽件时间，及时进行备货。平台承担物流费用，实际发货以揽件成功为准，当日揽收成功则免罚
                </span>
            </div>
        );
    }

    return null;
};

export default observer(PddCourierDoorToDoorCollectTip);
